import "./GuestBook.css";

import * as React from "react";
import { Form, Radio, RadioGroup, Text, Textarea } from "react-form";

type TIcon = "heart" | "unicorn" | "gorilla" | "gorilla2" | "flamingo";

interface IEntry {
    name: string;
    time: string;
    city: string;
    entry: string;
    icon: TIcon;
}

interface IGuestBookState {
    entries: Array<IEntry>;
    sendingEntry: boolean;
}

interface IApiGuestBookResponse {
    success: boolean;
}

export default class GuestBook extends React.Component<{}, IGuestBookState> {

    public constructor() {

        super();

        this.state = {
            entries: [],
            sendingEntry: false
        };
    }

    public componentDidMount() {

        this.getEntries();
    }

    public render() {

        return (
            <div className="GuestBook">
                <div className="GuestBook__title">
                    <span>GÄSTE&shy;</span>BUCH
                </div>
                <Form
                    onSubmit={(values) => {
                        const request = new XMLHttpRequest();

                        this.setState({
                            sendingEntry: true
                        });

                        const baseUrl = this.isDev ? "http://herzweg/" : "/";

                        request.open("POST", `${baseUrl}api/guestbook.php?action=post`, true);
                        // TODO: application/x-www-form-urlencoded??
                        request.setRequestHeader("Content-Type", "text/plain");

                        request.onload = () => {
                            const response: IApiGuestBookResponse = JSON.parse(request.responseText);

                            if (response.success) {
                                window.location.reload();
                            }

                            this.setState({
                                sendingEntry: false
                            });
                        };

                        request.send(JSON.stringify(values));
                    }}
                    validate={({ name, city, entry }) => {
                        return {
                            name: !name ? "Bitte gib Deinen Namen an" : undefined,
                            city: !city ? "Bitte gib Deine Heimat an" : undefined,
                            entry: !entry ? "Bitte gib einen Eintrag an" : undefined,
                        };
                    }}
                >
                    {({submitForm}) => {
                        return this.renderForm(submitForm);
                    }}
                </Form>
                <hr style={{ width: "100%", margin: "20px 0" }}/>
                {this.renderEntries()}
            </div>
        );
    }

    private get isDev() {
        return !!window.location.href.match(/localhost/);
    }

    private renderForm = (submitForm: () => void) => {

        const icons: Array<TIcon> = ["heart", "unicorn", "gorilla", "gorilla2", "flamingo"];

        return (
            <form onSubmit={submitForm}>
                <div style={{ margin: "4px 0" }}>
                    <label className="textInput">
                        <div className="label">Mein Name</div>
                        <Text id="name" field="name" maxLength={50}/>
                    </label>
                </div>
                <div style={{ margin: "4px 0" }}>
                    <label className="textInput">
                        <div className="label">
                            In dieser Stadt ist mein Wohnzimmer
                        </div>
                        <Text id="city" field="city" maxLength={50}/>
                    </label>
                </div>
                <div style={{ position: "relative", height: 550, }}>
                    <img
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        }}
                        src="assets/heart.png"
                    />
                    <label
                        style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: "100%",
                        }}
                        className="textArea"
                    >
                        <div className="label">Mein Eintrag</div>
                        <Textarea id="entry" field="entry"/>
                    </label>
                </div>
                <div style={{ marginTop: "23px" }} className="iconRadioGroup">
                    <RadioGroup field="icon">
                        <ul
                            style={{
                                listStyleType: "none",
                                margin: 0,
                                padding: 0,
                                display: "flex"
                            }}
                        >
                            {icons.map(icon => {
                                return (
                                    <li
                                        key={Math.random()}
                                    >
                                        <label
                                            style={{
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Radio name="icon" radioGroup="icon" value={icon}/>
                                            <img src={"assets/icons/" + icon + ".png"}/>
                                        </label>
                                    </li>
                                );
                            })}
                        </ul>
                    </RadioGroup>
                    <button type="submit">Senden</button>
                </div>
            </form>
        );
    }

    private renderEntries() {

        if (this.state.entries.length === 0) {
            return null;
        }

        return (
            <div>
                {this.state.entries.map((entry, idx) => {

                    const dateTime = new Date(entry.time);

                    const month = (dateTime.getMonth() < 9 ? "0" : "") + (dateTime.getMonth() + 1);
                    const day = (dateTime.getDate() <= 9 ? "0" : "") + (dateTime.getDate());
                    const date = day + "." + month + "." + dateTime.getFullYear();

                    const hours = (dateTime.getHours() < 10 ? "0" : "") + dateTime.getHours();
                    const minutes = (dateTime.getMinutes() < 10 ? "0" : "") + dateTime.getMinutes();
                    const time = hours + ":" + minutes;

                    const entryParagraphs = entry.entry.split(/(?:\r\n|\r|\n)+/);

                    return (
                        <div key={idx}>
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "15px"
                                    }}
                                >
                                    {entry.icon && (
                                        <img
                                            style={{
                                                height: "35px",
                                                marginRight: "10px"
                                            }}
                                            src={"assets/icons/" + entry.icon + ".png"}
                                        />
                                    )}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            color: "#b82434",
                                            fontWeight: 700
                                        }}
                                    >
                                        <div>{entry.name}</div>
                                        <div>{entry.city}, {date}, {time} Uhr</div>
                                    </div>
                                </div>
                                <div>
                                    {entryParagraphs.map((entryParagraph, paragraphIdx) => {
                                        return (
                                            <p key={paragraphIdx}>{entryParagraph}</p>
                                        );
                                    })}
                                </div>
                            </div>
                            <hr style={{ width: "100%", margin: "20px 0" }}/>
                        </div>
                    );
                })}
            </div>
        );
    }

    private getEntries() {

        const request = new XMLHttpRequest();

        const baseUrl = this.isDev ? "http://herzweg/" : "/";

        request.open("GET", `${baseUrl}api/guestbook.php?action=get`, true);
        // TODO: application/x-www-form-urlencoded??
        request.setRequestHeader("Content-Type", "text/plain");

        request.onload = () => {
            const response: Array<IEntry> = JSON.parse(request.responseText);
            this.setState({
                entries: response
            });
        };

        request.send();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/GuestBook.tsx